import React from "react";

import { Box, Typography } from "@mui/material";

import { EditableField } from "./EditableField";

interface SectionBreakHeaderProps {
  title: string;
  onTitleChange: (title: string) => void;
}

export const SectionBreakHeader: React.FC<SectionBreakHeaderProps> = ({ title, onTitleChange }) => {
  return (
    <Box
      sx={{
        bgcolor: "#071f35",
        p: "48px 48px 36px",
        display: "flex",
        alignItems: "flex-end"
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontSize: 10,
            fontWeight: 700,
            color: "rgba(255,255,255,0.45)",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            mb: 1
          }}
        >
          Section
        </Typography>
        <EditableField
          value={title}
          placeholder="Section title"
          onSave={onTitleChange}
          style={{ fontSize: 28, fontWeight: 700, color: "#FFFFFF", lineHeight: 1.25 }}
        />
      </Box>
    </Box>
  );
};
